//   যদি Database এ same page create করা হয়, তাহলে এই part ব্যবহার করা হবে। যদি না থাকে, তাহলে PageTemplate.js ফাইলটি ব্যবহার করা হবে।

//   import React from 'react';
//   import PageTemplate from './PageTemplate';
//   export default function InspectionProcess(props) { return <PageTemplate {...props} slug="Inspection_Process" />; }
//   ----------------------------------------------------------------------------------------------------------------------------------
import React, { useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';

function InspectionProcess({ view, setView, searchTerm, setSearchTerm, cityFilter, setCityFilter, setActiveTab }) {
  
  // পেজ লোড হলে একেবারে উপরে স্ক্রল করবে
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col font-sans">
      <Header view={view} setView={setView} setSearchTerm={setSearchTerm} setCityFilter={setCityFilter} setActiveTab={setActiveTab} />
      
      <main className="flex-1">
        
        {/* 🚨 HERO SECTION (Like Spinny) 🚨 */}
        <section className="relative bg-[#002f34] text-white py-20 overflow-hidden">
          <div className="max-w-[1200px] mx-auto px-6 flex flex-col md:flex-row items-center gap-12 relative z-10">
            <div className="flex-1 text-center md:text-left">
              <span className="text-[#ef5e33] font-black tracking-widest uppercase text-sm mb-4 block">
                Quality You Can Trust
              </span>
              <h1 className="text-5xl md:text-6xl font-black mb-6 leading-tight">
                Bah! <span className="text-[#ef5e33] italic">Certified</span>
              </h1>
              <p className="text-lg text-gray-300 font-bold mb-8 max-w-md mx-auto md:mx-0">
                Every car passes a rigorous 140-point inspection before it reaches you. If it doesn't pass, we don't sell it.
              </p>
              <div className="flex flex-wrap gap-4 justify-center md:justify-start">
                <div className="bg-white/10 px-6 py-3 rounded-full border border-white/20 font-bold flex items-center gap-2">
                  <span className="text-[#ef5e33]">✓</span> 140-Point Check
                </div>
                <div className="bg-white/10 px-6 py-3 rounded-full border border-white/20 font-bold flex items-center gap-2">
                  <span className="text-[#ef5e33]">✓</span> Non-Accidental
                </div>
              </div>
            </div>
            <div className="flex-1">
              {/* Premium Car Image for Hero */}
              <img 
                src="https://images.unsplash.com/photo-1494976388531-d1058494cdd8?auto=format&fit=crop&q=80&w=800" 
                alt="Certified Car Inspection" 
                className="w-full rounded-3xl shadow-2xl transform rotate-1 hover:rotate-0 transition duration-500 border-4 border-white/10"
              />
            </div>
          </div>
          {/* Background decorative blur */}
          <div className="absolute top-[-20%] right-[-10%] w-[600px] h-[600px] bg-[#ef5e33] rounded-full blur-[150px] opacity-20"></div>
        </section>

        {/* 🚨 STRICT REJECTION CRITERIA 🚨 */}
        <section className="py-20 bg-white">
          <div className="max-w-[1200px] mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-black text-[#002f34] uppercase">What we <span className="text-[#ef5e33]">reject</span></h2>
              <p className="text-gray-500 font-bold mt-4">We filter out the bad, so you only get the best.</p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                { title: 'Structural Damage', icon: '🚗', desc: 'Cars with accidental history or compromised chassis are instantly rejected.' },
                { title: 'Odometer Tampering', icon: '⏱️', desc: 'We strictly verify service records to ensure the miles driven are 100% genuine.' },
                { title: 'Flood Damaged', icon: '🌊', desc: 'Thorough checks to ensure the car has never been submerged or water-damaged.' }
              ].map((item, index) => (
                <div key={index} className="bg-gray-50 p-8 rounded-[2rem] text-center hover:shadow-xl transition duration-300 border border-gray-100">
                  <div className="text-5xl mb-4">{item.icon}</div>
                  <h3 className="text-xl font-black text-[#002f34] mb-3">{item.title}</h3>
                  <p className="text-gray-500 font-bold text-sm leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 🚨 THE 140-POINT INSPECTION GRID 🚨 */}
        <section className="py-20 bg-[#f4f7f6]">
          <div className="max-w-[1200px] mx-auto px-6">
            <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">
              <div>
                <h2 className="text-3xl md:text-4xl font-black text-[#002f34] uppercase">Our <span className="text-[#ef5e33]">140-Point</span> Inspection</h2>
                <p className="text-gray-500 font-bold mt-4 max-w-xl">Every inch of the car is meticulously checked by our expert mechanics using advanced diagnostic tools.</p>
              </div>
              <button onClick={() => setView('buy')} className="bg-[#002f34] text-white px-8 py-4 rounded-full font-black uppercase text-sm hover:bg-[#ef5e33] transition shadow-lg">
                View Certified Cars
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              
              {/* Card 1 */}
              <div className="bg-white p-8 rounded-[2rem] shadow-sm flex gap-6 hover:shadow-md transition">
                <div className="w-16 h-16 bg-[#fff3ec] text-[#ef5e33] rounded-2xl flex items-center justify-center text-3xl flex-shrink-0">⚙️</div>
                <div>
                  <h3 className="text-xl font-black text-[#002f34] mb-2">Engine & Transmission</h3>
                  <ul className="text-gray-500 font-bold text-sm space-y-2">
                    <li>• No unusual noise or smoke</li>
                    <li>• Smooth gear shifting</li>
                    <li>• No oil or coolant leaks</li>
                    <li>• Battery health & mounting</li>
                  </ul>
                </div>
              </div>

              {/* Card 2 */}
              <div className="bg-white p-8 rounded-[2rem] shadow-sm flex gap-6 hover:shadow-md transition">
                <div className="w-16 h-16 bg-[#e6f4f1] text-[#002f34] rounded-2xl flex items-center justify-center text-3xl flex-shrink-0">🚘</div>
                <div>
                  <h3 className="text-xl font-black text-[#002f34] mb-2">Exterior & Body</h3>
                  <ul className="text-gray-500 font-bold text-sm space-y-2">
                    <li>• Paint quality and dent checks</li>
                    <li>• Panel gaps alignment</li>
                    <li>• Windshield & glass conditions</li>
                    <li>• Headlights & taillights functionality</li>
                  </ul>
                </div>
              </div>

              {/* Card 3 */}
              <div className="bg-white p-8 rounded-[2rem] shadow-sm flex gap-6 hover:shadow-md transition">
                <div className="w-16 h-16 bg-[#f4f0ff] text-[#6c4df6] rounded-2xl flex items-center justify-center text-3xl flex-shrink-0">💺</div>
                <div>
                  <h3 className="text-xl font-black text-[#002f34] mb-2">Interior & Electricals</h3>
                  <ul className="text-gray-500 font-bold text-sm space-y-2">
                    <li>• AC cooling efficiency</li>
                    <li>• Infotainment & speakers</li>
                    <li>• Seat upholstery & dashboard</li>
                    <li>• Power windows & steering controls</li>
                  </ul>
                </div>
              </div>

              {/* Card 4 */}
              <div className="bg-white p-8 rounded-[2rem] shadow-sm flex gap-6 hover:shadow-md transition">
                <div className="w-16 h-16 bg-[#fff0f0] text-[#ff4757] rounded-2xl flex items-center justify-center text-3xl flex-shrink-0">🔧</div>
                <div>
                  <h3 className="text-xl font-black text-[#002f34] mb-2">Steering & Suspension</h3>
                  <ul className="text-gray-500 font-bold text-sm space-y-2">
                    <li>• Brake pad thickness</li>
                    <li>• Suspension noise & comfort</li>
                    <li>• Tyre tread depth & alignment</li>
                    <li>• Underbody rust & damage check</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* 🚨 FINAL CTA SECTION 🚨 */}
        <section className="py-20 text-center px-6">
          <h2 className="text-3xl font-black text-[#002f34] uppercase mb-4">Ready to drive your dream car?</h2>
          <p className="text-gray-500 font-bold mb-8">Browse our collection of fully inspected, certified used cars.</p>
          <button onClick={() => setView('buy')} className="bg-[#ef5e33] text-white px-10 py-5 rounded-2xl font-black uppercase tracking-wider hover:bg-[#d94e28] transition shadow-xl hover:shadow-2xl transform hover:-translate-y-1">
            Explore Cars Now
          </button>
        </section>

      </main>

      <Footer setView={setView} />
    </div>
  );
}

export default InspectionProcess;